import React from 'react';
import IntlMessages from 'Util/IntlMessages';

// type: primary secondary tertiary textAccent text textDanger subtle subtleDanger
// size: x-small small medium large

const BasicButton = ({ type = 'primary', textId, textMessage, disabled = false, size = 'medium', children, onClick = () => {}, ...props }) => {
  return (
    <div
      className={`basic-button ${type} ${size} ${disabled ? 'disabled' : 'cursor-pointer'} no-drag`}
      onClick={e => {
        if (disabled) return;
        onClick(e);
      }}
      {...props}
    >
      {children && children}
      {textId ? <IntlMessages id={textId} /> : textMessage}
    </div>
  );
};

export default BasicButton;
